import Const from 'const';
import {ComboUnitInterface} from 'services/key-player-stacking/combo-unit';
import {LineupStackCombinationsMapInterface} from 'components/organisms/key-player-combinations/interfaces/lineup-stack-combinations-map.interface';

const LineupStackCombinationsMap = {
    lineups: {},
    combinations: {},
};

class LineupKeyPlayerStackCombinations {
    constructor(public readonly data: LineupStackCombinationsMapInterface = LineupStackCombinationsMap) {}
    public getLineupIdsByCheckedCombinations(comboUnits: ComboUnitInterface[]): string[] {
        const {combinations} = this.data;

        const lineupIds: string[] = [];
        comboUnits.map((comboUnit) => {
            Object.keys(combinations[comboUnit.getUnitId()] || {}).map((lineupId) => lineupIds.push(lineupId));
        });

        return arrayUnique(lineupIds);
    }
}

const lineupKeyPlayerStackCombinations = new LineupKeyPlayerStackCombinations();

export default function (state = lineupKeyPlayerStackCombinations, action) {
    switch (action.type) {
        case Const.SET_LINEUP_KEY_PLAYER_STACK_COMBINATIONS_MAP:
            return new LineupKeyPlayerStackCombinations(action.data);

        case Const.UNSET_LINEUPS:
        case Const.RESET_ALL_SETTINGS:
        case Const.FILTER_BY_SLATE:
            return new LineupKeyPlayerStackCombinations();

        default:
            return state;
    }
}
